<h2 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span>Preview werkvakken ({{ data.features.length }} features)</span>
    <button mat-icon-button (click)="close()">
        <i class="fal fa-times"></i>
    </button>
</h2>

<mat-dialog-content class="feature-preview-dialog__content">
    <div class="table-responsive">
        <table class="table table-sm table-bordered feature-preview-dialog__table">
            <thead>
                <tr>
                    <th class="feature-preview-dialog__th">#</th>
                    @for (col of data.columns; track col) {
                        <th class="feature-preview-dialog__th">{{ col }}</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (feature of data.features; track $index; let i = $index) {
                    <tr>
                        <td>{{ i + 1 }}</td>
                        @for (col of data.columns; track col) {
                            <td class="max-width-coll">{{ feature.properties?.[col] }}</td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Sluiten</button>
</mat-dialog-actions>
